export default {
  l_Order_tasks: "Order tasks",
  l_Task: "Task",
  l_Kind: "Kind",
  l_Contact_client: "Contact client",
  l_Document_collection: "Document collection",
  l_Not_started: "Not started",
  l_In_progress: "In progress",
  l_Completed: "Completed",
  l_Document_collector: "Collector",
  l_Self: "Self",
  l_Broker: "Broker",
  l_Assignee: "Assignee",
  l_Deadline: "Deadline",
  l_By_orders: "By orders",
  l_List_view: "List",
  l_Filters: "Filters",
  l_Add_task: "Add task",
  "p_comments:delete": "Comments: Delete",
  "p_comments:edit": "Comments: Edit",
  "p_comments:create": "Comments: Create",
  "p_comments:view": "Comments: View",

  "p_price+proposals+++delete": "Price proposals: Delete",
  "p_price+proposals+++edit": "Price proposals: Edit",
  "p_price+proposals+++create": "Price proposals: Create",
  "p_price+proposals+++view": "Price proposals: View",

  "p_change+protected+statuses": "Change protected statuses",

  "p__request+rate": "Price requests",
  "p_delete+requests": "Requests: Delete",
  "p_editing+requests": "Requests: Edit",
  "p_create+requests": "Requests: Create",
  "p_view+requests": "Requests: View",

  "p_edit+contact": "Contacts: Edit",

  "p_change+credit+limit": "Credit limit: Change",

  "p_delete+clients": "Clients: Delete",
  "p_editing+clients": "Clients: Edit",
  "p_create+clients": "Clients: Create",
  "p_view+clients": "Clients: View",

  "p_delete+carriers": "Carriers: Delete",
  "p_editing+carriers": "Carriers: Edit",
  "p_create+carriers": "Carriers: Create",
  "p_view+carriers": "Carriers: View",

  "p_documents(transportation,+cmr,+photo):+view":
    "Documents (transportation, CMR, photo): View",

  "p_other:+view": "Other: View",
  "p_act:+view": "Act: View",

  "p_other:+create": "Other: Create",
  "p_other:+delete": "Other: Delete",
  "p_other:+edit": "Other: Edit",

  "p_acts:+create": "Acts: Create",
  "p_acts:+delete": "Acts: Delete",
  "p_acts:+edit": "Acts: Edit",

  "p_comments+create": "Comments: Create",
  "p_comments+edit": "Comments: Edit",
  "p_comments+delete": "Comments: Delete",
  "p_comments+view": "Comments: View",

  "p_view+order+tasks": "Order tasks: View",
  "p_create+order+tasks": "Order tasks: Create",
  "p_editing+order+tasks": "Order tasks: Edit",
  "p_delete+order+tasks": "Order tasks: Delete",
  "p_all+order+tasks": "Order tasks: All",

  "p_edit+paid+invoices": "Paid invoices: Edit",

  p_delete: "Delete",
  p_edit: "Edit",
  p_create: "Create",
  p_view: "View",

  "p_edit+paid+invoices_2": "Paid invoices: Edit",
  p_delete_2: "Delete",
  p_edit_2: "Edit",
  p_create_2: "Create",
  p_view_2: "View",

  "p_edit+order+status+history": "Order status history: Edit",
  "p_view+order+status+history": "Order status history: View",

  "p_delete+financial": "Financial: Delete",
  "p_edit+financial": "Financial: Edit",
  "p_view+financial": "Financial: View",

  "p_edit+freight": "Freight: Edit",
  "p_view+freight": "Freight: View",

  p_margin: "Margin",
  p_total: "Total",

  "p_trips+in+order": "Trips in order",

  "p_documents(transportation,+cmr,+phtoto)":
    "Documents (transportation, CMR, photo)",

  "p_cargo+information": "Cargo information",
  "p_client+information": "Client information",

  p_profit: "Profit",

  "p_delete+orders": "Orders: Delete",
  "p_edit+status": "Status: Edit",
  "p_editing+orders": "Orders: Edit",
  "p_create+orders": "Orders: Create",
  "p_view+orders": "Orders: View",

  "p_delete+trips": "Trips: Delete",
  "p_update+trips": "Trips: Update",
  "p_create+trips": "Trips: Create",
  "p_trips+view": "Trips: View",

  "p_your+own+departments+orders": "Your department's orders",
  "p_your+own+orders": "Your orders",
  "p_all+orders": "All orders",

  "p_your+own+departments+requests": "Your department's requests",
  "p_your+own+requests": "Your requests",
  "p_all+requests": "All requests",

  "p_your+own+departments+clients": "Your department's clients",
  "p_your+own+clients": "Your clients",
  "p_all+clients": "All clients",

  "p_your+own+departments+carriers": "Your department's carriers",
  "p_your+own+carriers": "Your carriers",
  "p_all+carriers": "All carriers",

  "p_your+own+departments+trips": "Your department's trips",
  "p_your+own+trips": "Your trips",
  "p_all+trips": "All trips",

  "p_view+additional+expenses": "Additional Expenses: View",
  "p_create+additional+expenses": "Additional Expenses: Create",
  "p_update+additional+expenses": "Additional Expenses: Update",
  "p_delete+additional+expenses": "Additional Expenses: Delete",
  "p_your+own+additional+expenses": "Your own additional expenses",
  "p_all+additional+expenses": "All additional expenses",
  "p_your+own+departments+additional+expenses":
    "Your department's additional expenses",

  l_Username: "Username",
  l_User_password: "User password",
  l_Forgot_password: "Forgot password",
  l_Forgot_password_title: "Password Recovery",
  l_Enter_email: "Enter your email",
  l_Send_reset_link: "Send reset link",
  l_Back_to_login: "Back to login",
  l_Reset_link_sent: "Code has been resent",
  l_Check_email_desc:
    "If the email exists, password reset instructions have been sent to your inbox.",
  l_Code_sent_hint: "Code sent to",
  l_Enter_code: "Enter the code from your email",
  l_Verify_code: "Verify",
  l_Resend_code: "Resend code",
  l_Back: "Back",
  l_New_password: "New password",
  l_Confirm_new_password: "Confirm new password",
  l_Reset_password: "Reset password",
  l_Passwords_not_match: "Passwords do not match",
  l_Password_reset_success: "Password has been successfully reset",
  l_Token_invalid: "Link is invalid or expired",
  l_Verifying_token: "Verifying link...",
  l_Step_email: "Email",
  l_Step_code: "Code",
  l_Step_password: "Password",
  l_Login: "Log in",
  l_Sign_out: "Sign out",
  l_EmailorPasswordisWrong: "Email or password is wrong",
  l_Requests: "Requests",
  l_Orders: "Orders",
  l_Order_code_referral: "Referral code",
  l_Order_code_referral_short: "Ref. code",
  l_Signing_condition: "Signing condition",
  l_New_status: "New status",
  l_Finance: "Finance",
  l_Clients: "Clients",
  l_Carriers: "Carriers",
  l_New_post: "New post",
  l_Settings: "Settings",
  l_Request_statuses: "Request statuses",
  l_Request_purposes: "Request purposes",
  l_Request_sources: "Request sources",
  l_Position_of_contact_persons: "Position of contact persons",
  l_Organization: "Organization",
  l_Templates: "Templates",
  l_Request_is_received: "Request is received",
  l_European_country: "European country",
  l_Request_number: "Request number",
  l_New_vat_rate: "New vat rate",
  l_Less: "Less",
  l_Business_number: "Type number",
  l_More: "More",
  l_Classifiers: "Classifiers",
  l_Position_of_contacts: "Position of contacts",
  l_System: "System",
  l_Classifier: "Classifier",
  l_Cargo_information: "Cargo information",
  l_Additional_info: "Additional info",
  l_Auto_pickup: "Auto pickup",
  l_Vat_rate: "VAT rate",
  l_Extremely_urgent: "Extremely urgent",
  l_Request_purpose: "Request purpose",
  l_Log: "Log",
  l_Companies: "Companies",
  l_Departments: "Departments",
  l_Employees: "Employees",
  l_Groups_of_employees: "Groups of employees",
  l_Company_name: "Company name",
  l_Name_in_original: "Name in original",
  l_Company_code: "Company code",
  l_VAT_code: "VAT code",
  l_Address: "Address",
  l_Seller: "Seller",
  l_Logistician: "Logistician",
  l_Address_for_correspondence: "Address for correspondence",
  l_Banks: "Banks",
  l_New_client: "New client",
  l_New_order: "New order",
  l_Cargo_statuses: "Cargo statuses",
  l_Client_types: "Client types",
  l_Organization_section: "Organization section",
  l_Document_statuses: "Document statuses",
  l_Order_statuses: "Order statuses",
  l_Price_proposals: "Price Proposals",
  l_Railway_stations: "Railway stations",
  l_Transport_types: "Transport types",
  l_Trip_statuses: "Trip statuses",
  l_VAT_rates: "VAT rates",
  l_Workers_posts: "Workers' posts",
  l_Whatsapp_notification_send: "Sending notifications to WhatsApp",
  l_Name: "Name",
  l_Unofficial_name: "Unofficial name",
  l_Branch: "Branch",
  l_Code__: "Code",
  l_Created: "Created",
  l_Updated: "Updated",
  l_Post_code: "Post code",
  l_Action: "Action",
  l_Add: "Add",
  l_Update: "Update",
  l_Edit: "Edit",
  l_Submit: "Submit",
  l_Cancel: "Cancel",
  l_Are_you_sure_delete_this_task: "Are you sure delete this task?",
  l_Yes: "Yes",
  l_No: "No",
  l_Keyword: "Keyword",
  l_Search: "Search",
  l_Active: "Active",
  l_Deleted: "Deleted",
  l_Include_deleted: "Include deleted",
  l_Initial: "Initial",
  l_Final: "Final",
  l_NotFound: "Not Found",
  l_Succeed: "Succeed",
  l_Segment_name: "Segment name",
  l_Segment_priority: "Segment priority",
  l_Color: "Color",
  l_By_default: "By default",
  l_Yellow: "Yellow",
  l_Green: "Green",
  l_Grey: "Grey",
  l_Red: "Red",
  l_Orange: "Orange",
  l_Status_name: "Status name",
  l_Priority: "Priority",
  l_Status_type: "Status type",
  l_Complete_order: "Complete order",
  l_Complete_order_confirm:
    "Complete the order? The client will get cargo receipt confirmation and service rating.",
  l_Text_colour: "Text color",
  l_Background_colour: "Background color",
  l_After_setting_status: "After setting status",
  l_Message_for_seller: "Message for seller",
  l_Topic_of_the_message_for_seller_TWIG:
    "Topic of the message for seller TWIG",
  l_Name_2: "Наименование",
  l_Railway_station: "Railway station",
  l_Code: "Code",
  l_Railway: "Railway",
  l_Railway2: "Railway",
  l_Failed_to_submit: "Failed to submit",
  l_Rate: "Rate",
  l_Give_access_to_carrier: "Give access to carrier",
  l_Valid_from: "Valid from",
  l_Notify_about_expiration: "Notify about expiration",
  l_Valid_until: "Valid until",
  l_VAT_law: "VAT law",
  l_third_part_code: "Third-part code",
  l_third_part_price: "Third-part price",
  l___CountVat: "__CountVat",
  l_Other_docs: "Other documents",
  l_Transportation_orders: "Transportation orders",
  l_Overhead_docs: "Overhead documents",
  l_Request_doc: "Documents for request",
  l_Default_VAT_rate: "Default VAT rate",
  l_Error: "Error",
  l_Status_requires_calculation:
    "You can change to this status only after create calculation!",
  l_Basic_information: "Basic information",
  l_Signatures: "Signatures",
  l_Directors_full_name: "Director's full name",
  l_In_the_name_of_whom: "In the name of whom",
  l_Post: "Post",
  l_VAT_rate: "VAT rate",
  l_RRC: "RRC",
  l_OGRN: "OGRN",
  l_Pricing_type: "Pricing type",
  l_Contact_information: "Contact information",
  l_Country: "Country",
  l_City: "City",
  l_Correspondent_information: "Correspondent information",
  l_Telephone: "Telephone",
  l_Fax: "Fax",
  l_Contact_partner: "Contact partner",
  l_Email: "Email",
  l_Email_text: "Email text",
  l_Website: "Website",
  l_Main_company: "Main company",
  l_Operating_account: "Operating account",
  l_Bank_code: "Bank code",
  l_Bank: "Bank",
  l_Calculations: "Расчеты",
  l_Different_invoices_for_different_currencies:
    "Different invoices for different currencies",
  l_Currency: "Currency",
  l_Correspondent_bank: "Correspondent bank",
  l_Print: "Print",
  l_Company_logotype: "Company logotype",
  l_Signature: "Signature",
  l_correspondent_account: "Сorrespondent account",
  l_Inc_VAT_price: "Inc VAT price",
  l_Ex_VAT_price: "Ex VAT price",
  l_Bank_name: "Bank name",
  l_Expences: "Expences",
  l_Wagon_number: "Wagon number",
  l_Margin: "Margin",
  l_Click_or_drag_ile_to_this_area_to_upload:
    "Click or drag file to this area to upload",
  l_Department_name: "Department name",
  l_Department_prefix: "Department prefix",
  l_Company: "Company",
  l_Request_status: "Request status",
  l_Received_payment: "Received payment",
  l_Total_issued_invoice: "Total issued invoice",
  l_Login_email: "Login email",
  l_Groups: "Groups",
  l_Name_Surname: "Name, Surname",
  l_Surname: "Surname",
  l_Date_of_last_visit: "Date of last visit",
  l_Mail_settings: "Mail settings",
  l_Password: "Password",
  l_Reset_your_password: "Are you sure you want to reset your password?",
  l_For_bonus: "% for bonus, %",
  l_Employee_prefix: "Employee prefix",
  l_Department: "Department",
  l_Term: "Term",
  l_New_payment_term: "New payment term",
  l_Access_rights: "Access rights",
  l_All: "All",
  l_Packagings: "Packagings",
  l_Packing_type: "Packing type",
  l_Container: "Container",
  l_Container_type: "Container type",
  l_Container_quantity: "Container quantity",
  l_Container_ownership: "Container ownership",
  l_Loading_by_carrier: "Loading by carrier",
  l_Calculation_data: "Calculation data",
  l_Category: "Category",
  l_Full_conditions: "Full conditions",
  l_Create_in_series: "Create in series",
  l_Series: "Series",
  l_Cargo_properties: "Cargo properties",
  l_Stackable: "Stackable",
  l_Regular_shape: "Regular shape",
  l_Fragile: "Fragile",
  l_Must_be_upright: "Must be upright",
  l_Magnetic: "Magnetic",
  l_Liquid: "Liquid",
  l_Powder: "Powder",
  l_Contains_battery: "Contains battery",
  l_Battery_type: "Battery type",
  l_Max_stack_weight: "Max stack weight",
  l_YourOwnDepartment: "Your Own Department",
  l_YourOwn: "Your Own",
  l_Contract_for_trips: "Contract for trips",
  l_History_payment: "History of payment",
  l_Received: "Payment date",
  l_New_calculation: "New calculation",
  l_Expence: "Expence",
  l_Name_of_the_kind_of_packing: "Name of the kind of packing",
  l_Request_date: "Request date",
  l_Exprired: "Expired",
  l_Contract_partner: "Contract partner",
  l_Refusal_reason: "The reason o the refusal of the request",
  l_Return_for_revision: "Return for revision",
  l_Return_reason: "Return reason",
  l_Enter_return_reason: "Enter return reason",
  l_Return_reason_required: "Return reason is required",
  l_Are_you_sure_to_cancel:
    "Are you sure, that you want to change request status to 'Unconfirmed'?",
  l_Unlimited_access: "Unlimited access",
  l_The_reason_of_refusal: "The reason of refusal of the request",
  l_Additional_information: "Additional information",
  l_Document_is_sending: "Document is sending",
  l_Sender: "Sender",
  l_Theme: "Theme",
  l_Workers_post: "Worker's posts",
  l_Different_acc_for_currency: "Different invoices for different currencies",
  l_Send: "Send",
  l_Copy: "Copy",
  l_Images_for_docs: "Images for documents",
  l_Director: "Director",
  l_Representive_name: "Representive name",
  l_Worker_post: "Worker's post",
  l_Company_prefix: "Prefix name",
  l_Stamp: "Stamp",
  l_Logo: "Logo",
  l_Sign: "Sign",
  l_Main: "Main",
  l_Cargos_and_routes: "Cargos and Routes",
  l_Trip_expenses: "Trips expenses",
  l_Destination: "Destination",
  l_Destination_time: "Destination time",
  l_Departure: "Departure",
  l_Departure_time: "Departure time",
  l_Type_of_transport: "Type of transport",
  l_Loading_place_custom: "Loading place customs",
  l_Without_stamp_and_sign: "Without stamops and sign",
  l_Have_expiration_date: "Have expiration date",
  l_Access: "Access",
  l_Country_from: "Country from",
  l_Country_to: "Country to",
  l_City_from: "City from",
  l_City_to: "City to",
  l_Confirm: "Confirm",
  l_Confirm_and_create: "Confirm and create",
  l_Payment_term: "Payment term",
  l_Total_received_invoice: "Total received invoice",
  l_New_splitting_status: "New splitting status",
  l_Total_weight: "Total weight",
  l_Add_service: "Add service",
  l_Element_rule_list: "Element in rule list",
  l_Direction: "Direction",
  l_Total_volume: "Total volume",
  l_Special_rights: "Special rights",
  l_Group: "Group",
  l_Donnot_count_in_balance: "Don't count in balance",
  l_Numeration: "Numeration",
  l_Numeration_name: "Numeration name",
  l_Numeration_for: "Numeration for",
  l_Employee: "Employee",
  l_Seperate_line_in_the_invoice: "Seperate line in the invoice",
  l_Prefix: "Prefix",
  l_Year: "Year",
  l_Month: "Month",
  l_Delimiter: "Delimiter",
  l_Number_of_digits: "Number of digits",
  l_Index: "Index",
  l_Suffix: "Suffix",
  l_View: "View",
  l_Client: "Client",
  l_Consolidation: "Consolidation",
  l_Cargos: "Cargos",
  l_TNVED_code: "HS code",
  l_Transport_count: "Transport count",
  l_Transit_date: "Transit date",
  l_Dimensions: "Dimensions (L×W×H)",
  l_Number_of_places: "Places",
  l_No_cargo: "No cargo added",
  l_Copy_all: "Copy all",
  l_Copied: "Copied",
  l_Copy_failed: "Failed to copy",
  l_Screenshot: "Screenshot",
  l_Screenshot_copied: "Screenshot copied",
  l_Screenshot_saved: "Screenshot saved",
  l_Screenshot_failed: "Failed to take screenshot",
  l_Trips: "Trips",
  l_Cargos_status: "Cargos status",
  l_Salary_calculation: "Salary calculation",
  l_Show_filters: "Show filters",
  l_Order_date: "Order date",
  l_Status_changed_at: "Status changed at",
  l_Date: "Date",
  l_Users: "Users",
  l_Documents: "Documents",
  l_Transport: "Transport",
  l_Other: "Other",
  l_Sort: "Sort",
  l_Are_you_sure_to_confirm:
    "Are you sure, that you want to confirm this request?",
  l_Order_number: "Order number",
  l_Order_status: "Order status",
  l_Loading_area: "Loading area",
  l_Unloading_area: "Unloading area",
  l_Loading_date: "Loading date",
  l_Days_of_trip: "Days of trip",
  l_Car_number: "Car Number",
  l_Freight: "Freight",
  l_Costs: "Costs",
  l_Status_characteristic: "Request characteristic",
  l_Profit: "Profit",
  l_User: "User",
  l_Deferred_payment_condition: "Deferred payment conditions",
  l_Trip_number: "Trip number",
  l_Weight: "Weight",
  l_New_request_purpose: "New request purpose",
  l_Request_purpose_name: "Request purpose name",
  l_Adding: "Adding",
  l_Volume: "Volume",
  l_Sorting: "Sorting",
  l_Reply_deadline: "Reply deadline",
  l_Cargo_ready_date: "Cargo ready date",
  l_Total_freight: "Total freight",
  l_Change_status: "Change status",
  l_XML_unloading: "XML unloading",
  l_Payment_type_name: "Payment type name",
  l_Auto_pick_up: "Auto pickup",
  l_New_trip: "New trip",
  l_Created_at: "Date of creation",
  l_Invoice_number: "Invoice number",
  l_Car_trip: "Car trip",
  l_Managers: "Managers",
  l_Template_section: "Template section",
  l_Invoice_issued: "Invoice issued",
  l_Rail_trip: "Railway trip",
  l_Date_of_creation: "Date of creation",
  l_Trailers_number: "Trailers number",
  l_Client_type: "Client type",
  l_Pay_until: "Pay until",
  l_Price_without_VAT: "Price withoit VAT",
  l_TIN_taxpayer_ID_number_VAT: "TIN/taxpayer ID number /VAT№",
  l_Activity_area: "Activity area",
  l_Postponement_days: "Postponement days",
  l_ContactInfo: "Contact info",
  l_OKPO: "OKPO",
  l_Template_group: "Template group",
  l_Add_line: "Add line",
  l_Price_with_V: "Price with VAT",
  l_Add_template: "Add template",
  l_Document_templates_group: "Document template group",
  l_New_city: "New city",
  l_Receiver: "Receiver",
  l_Cities: "Cities",
  l_Invoice_received: "Invoice received",
  l_Click_or_drag_file_to_this_area_to_upload:
    "Click or drag file to this area to upload",
  l_TIN: "TIN",
  l_Quantity: "Quantity",
  l_Invoicess_issued: "Issued invoice",
  l_Is_Use_nonstandard_invoice_template: "Is use nonstandard invoice template",
  l_Is_without_StampAnd_Signature: "Is without stamp and signature",
  l_Visible_for_client: "Visible for client",
  l_BIN: "BIN",
  l_Give_access_to_client: "Give access to client",
  l_Balance_of_payments: "Balance of payments",
  l_Payment_balance: "Payment balance",
  l_TRN: "TRN",
  l_RNN: "RNN",
  l_INN: "INN",
  l_KPP: "KPP",
  l_IIN: "IIN",
  l_Refusal_comment: "Refusal comment",
  l_Legal_address: "Legal address",
  l_Legal_name: "Legal name",
  l_Product_type: "Product type",
  l_Postal_address: "Postal address",
  l_Postal_code: "Postal code",
  l_Product: "Product",
  l_Received_date: "Received date",
  l_Payment_rules: "Payment rules",
  l_Credit_limit: "Credit limit",
  l_Payment_delay: "Payment delay",
  l_New_bank: "New bank",
  l_Is_Partial_Cargo: "Is partial cargo",
  l_Order_status_id: "Order status id",
  l_Limit_exceeded: "Limit exceeded",
  l_Deferred_payment_terms: "Deferred payment terms",
  l_Email_to_send_documents: "Email to send documents",
  l_Send_debt_remindings: "Send debt remindings",
  l_Swift: "Swift",
  l_Request_source: "Request source",
  l_PleaseEnterName: "Please Enter Name",
  l_Contact_persons_posts: "Contact persons' posts",
  l_Contact_person: "Contact person",
  l_Manager: "Manager",
  l_Days_from_the_latest_contract: "Days from the latest contract",
  l_Order_quantity: "Order quantity",
  l_Client_price: "Client price",
  l_Please_select_at_least_one_cargo: "Please select at least one cargo",
  l_Carrier_price: "Carrier price",
  l_Purchase_funnel: "Purchase funnel",
  l_Purchase_funnel_status: "Purchase funnel status",
  l_Phone: "Phone",
  l_Creation_date: "Creation date",
  l_Type_of_the_received_document: "Type of the received document",
  l_Contact_personnel: "Contact personnel",
  l_Successed: "Successed",
  l_Company_details: "Company details",
  l_Receiving_date: "Receiving date",
  l_Active_requests: "Active requests",
  l_Archive_requests: "Archive requests",
  l_Archive: "Archive",
  l_Duly_represtnted: "Duly represented...",
  l_Size: "Size",
  l_Income: "Income",
  l_Use_in_all_documents: "Use in all documents",
  l_Phone_number: "Phone number",
  l_Skype: "Skype",
  l_Fullname: "Fullname",
  l_Roles: "Roles",
  l_Work_time: "Work time",
  l_Reset: "Reset",
  l_ICQ: "ICQ",
  l_Logs: "Logs",
  l_Session_log: "Session log",
  l_Data: "Data",
  l_Delete: "Delete",
  l_ID_session: "ID Session",
  l_Brouser: "Brouser",
  l_Comments: "Comments",
  l_List_empty: "List is empty",
  l_Access_to_req: "Access to permissions",
  l_PasswordNotLessThan6Letters: "Password Not Less Than 6 Letters",
  l_Existed: "Existed",
  l_Permission_settings: "Permission settings",
  l_EmailExisted: "Email Existed",
  l_Clients_order_number: "Client's order number",
  l_Contacts: "Contacts",
  l_Default_forwarder: "Coordinator",
  l_Additional_managers: "Freight coordinator",
  l_Price: "Price",
  l_Price_with_VAT: "Price with VAT",
  l_Deferred_payment_days: "Deferred payment (days)",
  l_Deferred_payment_conditions: "Deferred payment conditions",
  l_Full_text: "Full text",
  l_Group_name: "Group name",
  l_Full_name: "Fullname",
  l_Carrier_types: "Carrier types",
  l_Group_of_employees: "Group of employees",
  l_One_or_more_content_missing: "One or more of the content is missing",
  l_Statuses: "Statuses",
  l_Invoices: "Invoices",
  l_Delivery_terms: "Delivery terms(по Инко термс 2010)",
  l_Transit_time: "Transit time",
  l_Waybill_number: "RWB/AWB/CMR",
  l_Ttn_number: "TTN number",
  l_Vehicle_or_container_number: "Vehicle / container number",
  l_Borders: "Borders",
  l_Reloading_place: "Reloading place",
  l_Order_detail: "Order detail",
  l_Tasks: "Tasks",
  l_New_carrier: "New carrier",
  l_External_trip: "External trip",
  l_Number: "Number",
  l_Number_in_carrier_system: "Number in carrier system",
  l_Choose_client: "Choose client",
  l_Initial_freight: "Initial freight",
  l_Expenses: "Expenses",
  l_Forwarders: "Forwarders",
  l_Documents_with_clients: "Documents with clients",
  l_Cargo_number: "Cargo number",
  l_Reloading_date: "Reloading date",
  l_Cargo_name: "Cargo name",
  l_Cargo_parameters: "Cargo parameters",
  l_Loading: "Loading",
  l_Is_general: "Is general",
  l_Notification: "Notification",
  l_New_payment: "New payment",
  l_There_is_nothing: "There are no notifications",
  l_Payment_amount: "Payment amount",
  l_Payment_date: "Payment date",
  l_Payment_type: "Payment type",
  l_You_dont_have_permission: "You do not have a permisiion to this action",
  l_Cash: "Cash",
  l_Cashless: "Cashless",
  l_Price_show: "Cost details",
  l_Is_automating_sending: "Is automating sending",
  l_Custom_data: "Unloading place customs",
  l_Custom_loading_data: "Loading place customs",
  l_Reloading_storage_place: "Reloading/storage place",
  l_Date_of_transhipment: "Date of transhipment",
  l_Unloading: "Unloading",
  l_Consignment_Price: "Consignment Price",
  l_New_user: "New user",
  l_Loading_place: "Loading place",
  l_Time: "Time",
  l_Save: "Save",
  l_Place_Company: "Place / Company",
  l_Trip_or_cargo_number: "No. trip/consignment",
  l_Rate_date: "Rate date",
  l_Contact_person_and_telephone: "Contact person and telephone",
  l_Loading_place_customs: "Loading place customs",
  l_To: "To",
  l_Unloading_place: "Unloading place",
  l_Unloading_place_customs: "Unloading place customs",
  l_Packing_type_quantity: "Packing type/quantity",
  l_Pallets: "Pallets",
  l_LDM: "LDM",
  l_Length: "Length",
  l_Width: "Width",
  l_Height: "Height",
  l_Partial_cargo: "Partial cargo",
  l_Cargo_additional_information: "Cargo additional information",
  l_Attributes: "Attributes",
  l_Insurance: "Insurance",
  l_Terms_of_delivery: "Terms of delivery (according to Incoterms 2010)",
  l_Transit_Time: "Transit time",
  l_Status: "Status",
  l_Unloading_date: "Unloading date",
  l_New_cargo: "New cargo",
  l_Carrier: "Carrier",
  l_Forwarder: "Forwarder",
  l_New_rail_station: "New rail station",
  l_Station: "Station",
  l_Rail_station: "Rail station",
  l_Received_invoices: "Received invoices",
  l_Cargos_and_Routes: "Cargos and Routes",
  l_Carrier_company: "Carrier company",
  l_Carrier_contract_number_with_carrier:
    "Carrier contract number with carrier",
  l_Insurance_policy_valid_until: "Insurance policy valid until",
  l_Number_in_carriers_system: "Number in carrier's system",
  l_Trip: "Trip",
  l_Terms_and_conditions_of_payment: "Terms and conditions of payment",
  l_Vehicle_number: "Vehicle number",
  l_Trailers_numbers: "Trailers numbers",
  l_Transport_type: "Transport type",
  l_Loading_method: "Loading method",
  l_Passport_number: "Passport number",
  l_Driver: "Driver",
  l_Container_number: "Container number",
  l_Sizes_L_W_H: "Sizes (L*W*H)",
  l_Amount: "Amount",
  l_Packing: "Packing",
  l_Order: "Order",
  l_Route: "Route",
  l_Change_password: "Change password",
  l_Client_to_user: "Access for clients",
  l_Carrier_to_user: "Access for carriers",
  l_Notification_language: "Notification language",
  l_Cargo_status: "Cargo status",
  l_Received_invoice: "Received invoice",
  l_Expense: "Expense",
  l_Expenses_incl_VAT: "Expenses incl. VAT",
  l_Dont_count_in_balance: "Don't count in balance",
  l_Separate_line_in_the_invoice: "Separate line in the invoice",
  l_Expense_description: "Expense description",
  l_Document_name: "Document name",
  l_Document_expiration_date: "Document expiration date",
  l_Available_for_client: "Available for client",
  l_Show_to_client: "Show to client",
  l_Type: "Type",
  l_Template: "Template",
  l_Attached_file: "Attached file",
  l_Document_number: "Document number",
  l_Document_date: "Document date",
  l_Provide_access_to_the_client: "Provide access to the client",
  l_File: "File",
  l_OverheadDocuments: "Overhead documents",
  l_Tags: "Tags",
  l_Rail_trips: "Rail trips",
  l_OtherDocuments: "Other documents",
  l_Acts: "Acts",
  l_Photos: "Photos",
  l_Link: "Link",
  l_To_comment: "To comment",
  l_Comment: "Comment",
  l_Cargo: "Cargo",
  l_Place: "Place",
  l_ETA: "ETA",
  l_Sent: "Sent",
  l_Author: "Author",
  l_Trip_type: "Trip type",
  l_Neutral: "Neutral",
  l_Finish: "Finish",
  l_Change_the_status_of_cargo_on_this_flight:
    "Change the status of cargo on this flight",
  l_Are_you_sure_you_want_to_update: "Are you sure you want to update?",
  l_Finance_template: "Finance template",
  l_Wagon_data: "Wagon data",
  l_New_country: "New country",
  l_Default_country: "Default country",
  l_Train_Trip_number: "Train/Trip number",
  l_Car_Container_number: "Car/Container number",
  l_Cargo_data: "Cargo data",
  l_GNG_code: "GNG code",
  l_Classes_of_transport_rates: "Classes of transport rates",
  l_Rules_for_using_the_car: "Rules for using the car",
  l_Wagon_renter: "Wagon renter",
  l_Freight_with_VAT: "Freight with VAT",
  l_Login_: "Login",
  l_Close: "Close",
  l_Directions: "Directions",
  l_Add_cargo: "Add cargo",
  l_Comment_type: "Comment type",
  l_Provide_access_to_carrier: "Provide access to carrier",
  l_From: "From",
  l_Countries: "Countries",
  l_Drivers_name: "Driver's name",
  l_Drivers_surname: "Driver's surname",
  l_Middle_name: "Middle name",
  l_Passport: "Passport",
  l_Driving_licence_number: "Driving licence number",
  l_Driving_licence_categories: "Driving licence categories",
  l_Fuel_card: "Fuel card",
  l_Is_active: "Is active",
  l_Bank_account: "Bank account",
  l_Contact_type: "Contact type",
  l_Export_to_excel: "Excel",
  l_Vehicle: "Vehicle",
  l_Shipment: "Shipment",
  l_Change_group_cargo_status: "Change cargo status by group",
  l_Transportation: "Transportation documents",
  l_Price_and_payment_term: "Price and payment term",
  l_Issued_invoice: "Issued invoice",
  l_Overhead: "Overhead documents",
  l_Freezing_order: "Freezing order",
  l_Additional_expenses: "Additional expenses",
  l_Trip_costs: "Trip costs",
  l_Unrecorded_expenses:
    "Unrecorded expenses - expenses marked with the checkbox 'unaccounted expenses'",
  l_Specifications: "Specifications",
  l_Copying: "Copying",
  l_Apply: "Apply",
  l_updateStatus: "Update status",
  l_Date_of_employment: "Date of employment",
  l_Euro_emission_class: "Euro emission class",
  l_Trailer_number: "Trailer number",
  l_Brand: "Brand",
  l_Cargo_price: "Cargo price",
  l_Expense_templates: "Expense template",
  l_Model: "Model",
  l_Rail_stations: "Rail stations",
  l_Production_date: "Production date",
  l_Body_number: "Body number",
  l_Registration_date: "Registration date",
  l_Tech_passport_validity: "Tech passport validity",
  l_License_number: "License number",
  l_License_validity_date: "License validity date",
  l_Drivers: "Drivers",
  l_Transport_information: "Transport information",
  l_Vehicle_empty_weight: "Vehicle empty weight",
  l_Vehicle_full_weight: "Vehicle full weight",
  l_Vehicle_axels: "Vehicle axels",
  l_New_company: "New company",
  l_Max_weight: "Max weight",
  l_Max_euro_pallets: "Max euro pallets",
  l_Relevant_documents: "Relevant documents",
  l_Document_groups: "Document groups",
  l_Template_name: "Transportation name",
  l_Is_default: "Is default",
  l_Service_type: "Service type",
  l_Statistical: "Statistical",
  l_New_contact_person: "New contact person",
  l_Statistic: "Statistic",
  l_Unregistered: "Unregistered",
  l_Role: "Role",
  l_Permission: "Permission",
  l_Description: "Description",
  l_Services: "Services",
  l_Peromission_key: "Permission key",
  l_Parent_option: "Parent option",
  l_Level: "Level",
  l_Border_point: "Border point",
  l_Cost_per_cargo: "Cost per cargo",
  l_By_weight: "By weight",
  l_By_volume: "By volume",
  l_By_weight_and_volume: "By weight and volume",
  l_Batch_setting_cargo_status: "Batch setting cargo status",
  l_Select: "Select",
  l_Selected: "Selected",
  l_not_selected: "Not selected",
  l_Distribute_percent: "Distribute percent",
  l_Distribute_price: "Distribute price",
  l_Total: "Total",
  l_Clear: "Clear",
  l_By: "By",
  l_Add_date: "Add date",
  l_Update_date: "Update date",
  l_Descending: "Descending",
  l_Ascending: "Ascending",
  l_Invoice: "Invoice",
  l_Invoices_issued: "Invoices issued",
  l_invoiceNumber: "Invoice Number",
  l_senderInvoice: "Company",
  l_issuedDate: "Invoice issued",
  l_receivingDate: "Date of receiving",
  l_payUntilDate: "Pay until",
  l_Trip_status: "Trip status",
  l_Without_VAT: "Without VAT",
  l_With_VAT: "With VAT",
  l_Change_order_status: "Change order status",
  l_Invoice_line: "Invoice line",
  l_Unit: "Unit",
  l_Received_from: "Received from",
  l_Company_which_received_the_invoice: "Company, which received the invoice",
  l_Breaking_rule: "Breaking rule",
  l_Contractor: "Contractor",
  l_Empty: "Empty",
  l_No_data: "No data",
  l_Payer: "Payer",
  l_Language: "Language",
  l_Made: "Made",
  l_Notes: "Notes",
  l_Devider: "Devider",
  l_Element: "Element",
  l_Percent: "Percent",
  l_INN_EGRPOU_VAT_BIN_UNN: "INN, EGRPOU, VAT, BIN, UNN",
  l_Start: "Start",
  l_End: "End",
  l_Contract_date: "Contract date",
  l_Contract_number: "Contract number",
  l_Has_contract: "Has contract",
  l_Contragents: "Contragents",
  l_Issued_invoice_in_order: "Issued invoice in order",
  l_Status_history: "Status history",
  l_New_request: "New request",
  l_Classifier_section: "Classifier section",
  l_Add_places: "Add route from cargo",
  l_Client_type_definition:
    "Client types - classification of Clients by importance/urgency. Filled out in the Client card and interacts with Requests. When filling out the directory, you can set the priority of the segment. This figure determines the importance and position of the Request from a client with this Type. It works like this: add VIP Client Type to the directory, segment priority is 1. Next, in the card of the desired Client, select this type and all requests from this Client will be located at the very top of the general Requests table, regardless of the order in which they were received. You can also use a filter in the Clients block to make a selection by Clients of a certain Type.",
  l_Company_is_required: "Select company",
  l_File_is_required: "Upload files",
  l_Comment_is_required: "Enter comment",
  l_Contract_is_required: "Select contract",
  l_Document_name_is_required: "Enter document name",
  l_Company_name_is_required: "Enter company name",
  l_Expense_name_required_without_template:
    "Name is required when no template is selected",
  l_Business_number_is_required: "Enter number",
  l_Required_field: "Required field",
  l_Select_required: "Select value",
  l_Type_to_search_orders: "Type to search orders",
  l_Transfer_client: "Transfer client",
  l_Transfer: "Transfer",
  l_Transfer_history: "Transfer history",
  l_New_manager: "New manager",
  l_From_manager: "From manager",
  l_To_manager: "To manager",
  l_Performed_by: "Performed by",
  l_Selected_clients: "Selected clients",
  l_Refresh: "Refresh",
  l_System_break: "System break",
  l_Active_break: "Active break",
  l_No_active_break: "No active break",
  l_Break_reason: "Break reason",
  l_Break_reason_placeholder: "E.g.: Lunch break",
  l_Break_reason_required: "Please enter a break reason",
  l_Break_from: "From",
  l_Break_to: "To",
  l_Break_time_required: "Please specify start and end time",
  l_Break_started_by: "Started by",
  l_Add_break: "Add break",
  l_Start_break: "Start break",
  l_Stop_break: "Stop break",
  l_Stop_break_confirm: "Are you sure you want to stop the break early?",
  l_System_on_break: "System is on break",
  l_Break_ends_at: "Break ends at",
  l_Break_history: "Break history",
  l_Finished: "Finished",
  l_Generate_sno: "Generate СНО",
  l_Create: "Create",
  l_General_invoice: "General invoice",
  l_Create_general_invoice: "Generate general invoice",
  l_General_invoice_created: "General invoice created",
  l_General_invoice_create_error: "Could not create the general invoice",
  l_Shortfall_invoice: "Shortfall invoice",
  l_Create_shortfall_invoice: "Create shortfall invoice",
  l_Shortfall_invoice_created: "Shortfall invoice created",
  l_Shortfall_invoice_error: "Could not create the shortfall invoice",
  l_Shortfall_invoice_source: "Shortfall from invoices: {invoices}",
  l_Shortfall_invoice_source_unknown: "Shortfall from paid invoices",
  l_Shortfall_to_pay: "Remaining to pay",
  l_Shortfall_amount: "Rate shortfall (additional invoice needed)",
  l_Download_avr: "Download AVR",
  l_Download_realization: "Download realization",
  l_OneC_document_not_ready: "1C has not sent the document yet",
  l_Split_into_tranches: "Split into payment tranches",
  l_First_tranche: "First tranche, %",
  l_Second_tranche: "Second tranche, %",
  l_Rate_source: "USD rate source",
  l_Nbrk_rate: "NBRK rate",
  l_Forte_rate: "Forte",
  l_Manual_rate: "Manual rate",
  l_Sno_auto_updated: "Auto-updated",
  l_Paid_by_1c: "Paid according to 1C",
  l_From_date: "on",
  l_Document: "document",
  l_Rate_source_change_hint:
    "The invoice will be recalculated using the selected source's rate and resent to 1C. Not allowed if the invoice already has a payment.",
  l_Rate_source_change_separately:
    "Changing the rate source is a separate action: save the other edits first, then change the rate source from the invoice list.",
  l_Approve: "Approve",
  l_Download_xlsx: "Download XLSX",
  l_Download_pdf: "Download PDF",
  l_Manual_exchange_rates: "Manual USD rates",
  l_Usd_kzt_rate: "KZT to USD rate (KZT/USD)",
  l_Rate_kzt_per_usd: "Rate, KZT per 1 USD",
  l_Add_rate: "Add rate",
  l_File_not_ready: "Invoice file is not ready yet, try again later",
  l_Specify_both_tranches: "Specify a percentage for both tranches",
  l_Select_payer: "Select a payer",
  l_Select_vat_rate: "Select a VAT rate",
  l_Add_at_least_one_line: "Add at least one invoice line",
  l_Fill_line_description: "Fill in the description for all invoice lines",
  l_Invalid_line_amount: "Enter a valid amount in all invoice lines",
  l_Invalid_line_price: "Enter a valid price in all invoice lines",
  l_Status_requires_review: "Requires review",
  l_Status_approved: "Approved",
  l_Status_sent_to_1c: "Sent to 1C",
  l_Status_sent_to_client: "Sent to client",
  l_Status_completed_by_1c: "Completed by 1C",
  l_Status_awaiting_payment: "Awaiting payment",
  l_Status_partially_paid: "Partially paid",
  l_Status_paid: "Paid",
  l_Status_realized: "Realized",
  l_Status_error_from_1c: "1C error",
  l_Status_resent_to_1c: "Resent to 1C",
  l_Resubmit_sno_note: "The same invoice will be sent with payer details refreshed from the client card. Changed amounts and lines will not be sent.",
  l_Sno_already_sent_to_1c: "The invoice has already been sent to 1C",
  l_Sno_not_sent_to_1c_yet: "The invoice has not been sent to 1C yet — approve it first",
  l_OneC_error_contract_hint: "An accountant must create a contract in this currency in 1C, or change the invoice currency to KZT",
  l_OneC_error_bin_not_found: "Payer BIN not found in 1C",
  l_OneC_error_required_field_missing: "Required field is missing",
  l_OneC_error_invalid_template: "Invalid invoice template",
  l_OneC_error_document_not_found: "Document not found in 1C",
  l_OneC_error_document_update_error: "Failed to update document in 1C",
  l_OneC_error_internal: "Internal 1C error",
  l_OneC_error_bin_hint: "Check the BIN in the client card (12 digits) and resubmit the invoice",
  l_Open_payer_card: "Payer card",
  l_Field: "Field",
  l_Resubmit_sno: "Resend to 1C",
  l_Version: "Version",
  l_Sno_history: "СНО history",
  l_Version_actual: "Current",
  l_Version_replace_reason: "Replacement reason",
  l_New_version_warning:
    "A new version of the document will be created. The previous version stays in history.",
  l_Sno_not_formed: "СНО is not generated yet — editing is unavailable",
  l_Avr: "AVR",
  l_Generate_avr: "Generate AVR",
  l_Avr_required: "AVR required",
  l_Avr_type: "AVR type",
  l_Avr_electronic: "Electronic",
  l_Avr_paper: "Paper",
  l_Avr_status_not_requested: "Not requested",
  l_Avr_status_requested: "Requested",
  l_Avr_status_in_progress: "In progress",
  l_Avr_status_formed: "Generated",
  l_Avr_status_error: "Error",
  l_Open: "Open",
  l_Download: "Download",
  l_Client_bin: "Client BIN",
  l_Already_formed: "Already generated",
  l_Select_all: "Select all",
  l_Deselect_all: "Deselect all",
  l_All_electronic: "Set all to Electronic",
  l_All_paper: "Set all to Paper",
  l_Avr_bulk_confirm:
    "Send the accountant an AVR request for the selected orders ({n})?",
  l_Request_sent: "Request sent",
  l_Result: "Result",
  l_Nothing_selected: "No orders selected",
  l_Updated_by: "Updated by",
  l_Updated_at: "Updated at",
  l_Tranche: "Tranche",
  l_Save_as_template: "Save as template",
  l_Template_saved: "Template saved",
  l_Delete_template_confirm: "Delete this template?",
  l_Delete_invoice_confirm: "Delete this invoice?",
  l_Template_name_optional: "Name (optional)",
  l_Editing: "Editing",
  l_CN_operators: "Operators",
  l_CN_operator: "Operator",
  l_Freight_coordinators: "Freight coordinators",
  l_Freight_coordinator: "Freight coordinator",
  l_Logisticians: "Logisticians",
  l_Manager_assignment_templates: "Manager assignment templates",
  l_Product_type_assignment_templates: "Product type assignment templates",
  l_Already_assigned: "already assigned",
  l_Product_type_already_assigned:
    "Product type(s) already assigned to another template: {items}",
  l_Exchange_rates: "Exchange rates",
  l_Forte_rates: "ForteBank rates",
  l_Rate_sell: "Sell rate",
  l_Fetched_at: "Fetched from Forte",
  l_Forte_rate_not_found: "No rate found for the selected date",
  l_Forte_rate_not_found_hint:
    "Rates are stored by a daily job at about 09:00, so there is no data for future dates or for today before the job runs. CNY is not collected at all.",
  // Request document approval
  l_Approval_status: "Approval status",
  l_Doc_status_todo: "Not submitted",
  l_Doc_status_review: "Under review",
  l_Doc_status_approved: "Approved",
  l_Doc_status_rejected: "Rejected",
  l_Doc_status_uploaded_by_client: "Uploaded by the client",
  l_Doc_status_approved_by_client: "Approved by the client",
  l_Confirm_document: "Approve document",
  l_Reject_document: "Reject document",
  l_Rejection_reason: "Rejection reason",
  l_Enter_rejection_reason: "E.g. the scan is unreadable, please resend",
  l_Rejection_reason_required: "Enter the rejection reason",
  // Request info from client
  l_Request_info_from_client: "Request info from client",
  l_Info_requested_from_client: "Info requested",
  l_Edit_info_request: "Edit info request",
  l_What_is_needed: "What is needed from the client",
  l_Info_request_comment_placeholder: "E.g. needed before we quote the rate",
  l_Reminders: "Reminders",
  l_Waiting_answer: "Awaiting answer",
  l_Closed: "Closed",
  l_Close_request: "Close request",
  l_Are_you_sure_delete_info_request: "Delete the info request?",
  l_Info_item_packing_list: "Packing list with box count",
  l_Info_item_invoice: "Invoice",
  l_Info_item_tnved_code: "HS (TN VED) code",
  l_Info_item_cargo_photo: "Cargo / pallet photo",
  l_Info_item_specification: "Item specification",
  l_Cadence_off: "No reminders",
  l_Cadence_6h: "Every 6 hours",
  l_Cadence_12h: "Every 12 hours",
  l_Cadence_24h: "Every 24 hours",
  l_Cadence_48h: "Every 48 hours",
  l_Cadence_72h: "Every 72 hours",
  l_Cadence_off_hint: "No reminders will be sent to the client",
  // Cross-request info request list
  l_Info_requests: "Info requests",
  l_Partially_answered: "Partially answered",
  l_Answered_at: "Answered at",
  l_Requested_by: "Requested by",
  l_Requested_at: "Requested at",
  l_Client_answered: "Client answered",
  l_Any: "Any",
  l_Preset_waiting_client: "Awaiting client",
  l_Preset_partially_answered: "Partially answered",
  l_Preset_all_active: "All active",
  l_Info_request_pending_items: "Awaiting from client",
  // Client response to a price proposal
  l_Client_response: "Client response",
  l_Client_accepted: "Accepted",
  l_Client_declined: "Declined",
  l_Client_comment: "Client comment",
  l_No_answer_yet: "No answer",
  l_Sales_plans: "Sales plans",
  l_Plan_type: "Plan type",
  l_Plan_type_KNR: "China plan",
  l_Plan_type_EUROPE: "Europe plan",
  l_Monthly_targets: "Monthly targets",
  l_Yearly_target: "Yearly target",
  l_Yearly_target_hint: "sum of monthly targets, calculated automatically",
  l_Months_filled: "Months filled",
  l_Scope: "Show",
  l_My_plans: "My plans",
  l_All_plans: "All plans",
  l_Calls_count: "Calls count",
  // Order documents: approval with the client (.todo/order-updates.md)
  l_Draft_type: "Draft type",
  l_Draft_type_cmr: "CMR",
  l_Draft_type_rwb: "RWB",
  l_Draft_type_awb: "AWB",
  l_Draft_type_declaration: "Export declaration",
  l_Document_type: "Document type",
  l_Request_from_client: "Request from the client",
  l_Request_reason: "Reason for the request (visible to the client)",
  l_Template_for_client: "Template for the client",
  l_Save_and_send_to_client: "Save and send to client",
  l_Send_to_client: "Send to client",
  l_Reupload_document: "Re-upload document",
  l_Upload_own_version: "Upload your version",
  l_Waiting_for_client: "Waiting for the client",
  l_Your_turn: "Your turn",
  l_Send_again: "Send again",
  l_Client_file: "Client file",
  l_Replace_template: "Replace template",
  l_Template_client_hint: "The client sees the template, attaches their filled-in file and sends it back for your approval. The file goes to the client as is, in any format — PDF, DOCX, XLSX, a scan.",
  l_Template_reupload_hint: "The new file replaces the template, the client file is cleared and the turn goes back to the client.",
  l_Doc_error_pending_manager: "The document is already under review",
  l_Doc_error_not_pending_manager:
    "It is the client's turn — approval is unavailable",
  l_Doc_error_already_approved:
    "The document is approved, changes are unavailable",
  l_Doc_error_file_required: "Attach at least one file",
  l_Doc_error_not_found: "Document not found, the list has been refreshed",
  l_Created_by_client: "Created by client",
  l_Created_by_client_hint: "The client created this request in their portal",
  l_Client_returned: "The client returned it",
  l_Catalog_technical_description: "Technical description",
  l_Catalog_intended_use: "Statement of intended use",
  l_Catalog_declaration_conformity: "Declaration of conformity",
  l_Catalog_knb_approval: "KNB approval",
  l_Catalog_rgi_approval: "RGI approval",
  l_Catalog_miid_approval: "MIID approval",
  l_Catalog_ses_exemption: "SES exemption letter",
  l_Catalog_state_registration: "State registration certificate",
  l_Catalog_registration_certificate: "Registration certificate",
  l_Catalog_import_license: "Import license",
  l_Catalog_knb_notification: "KNB notification",
  l_Catalog_invoice: "Invoice",
  l_Catalog_packing_list: "Packing list",
  l_Catalog_authenticity: "Authenticity",
  l_Catalog_other: "Other",
  l_Request_document_from_client: "Request a document from the client",
  l_Sure_send_to_client: "Send the document to the client?",
  l_Sure_confirm_document: "Confirm the client's document?",
  l_Responded_at: "Client response",
  // Обязательные документы клиента (.todo/mandatory-client-documents-fe.md)
  l_Mandatory_document: "Mandatory",
  l_Mandatory_document_hint:
    "The document is mandatory for the client: it cannot be deleted and its type cannot be changed",
  // Согласование цены (.todo/price-negotiation-api.md)
  l_Price_negotiation: "Price negotiation",
  l_No_price_negotiation: "Price negotiation has not started yet",
  l_Calculation: "Calculation",
  l_Client_decision_review: "Under review",
  l_Client_decision_accepted: "Client accepted",
  l_Client_decision_declined: "Client declined",
  l_Client_proposals: "Client counter offers",
  l_Client_proposed_price: "Client price",
  l_Offered_price: "Offered by manager",
  l_Agreed_price: "Agreed price",
  l_Status_code: "Status code",
  l_Feedback_reasons: "Order feedback reasons",
  l_Positive: "Positive",
  l_Negative: "Negative",
  // Онбординг клиента: гайды по продуктам (.todo/client-onboarding.md)
  l_Product_guides: "Product guides",
  l_Guide_text: "Guide text",
  l_Only_active: "Only active",
  l_Guide_category_air: "Air",
  l_Guide_category_train: "Rail",
  l_Guide_category_auto: "Road",
  l_Guide_category_auto_eu: "Road (EU)",
  l_Guide_category_kz_kz: "Domestic (KZ)",
  l_Requires_signature: "Contract to be signed",
  l_Awaiting_signature: "Awaiting signature",
  l_Signed: "Signed",
  l_Export_cooldown_hint:
    "The export is already running. You can repeat it in {n} sec.",
  // Document version history (DocumentRevision): files replaced by newer ones
  l_Document_history: "Document version history",
  l_Uploaded_at: "Uploaded at",
  l_Uploaded_by: "Uploaded by",
  l_Calculation_accepted_by_client_locked:
    "The price proposal has been accepted by the client and is locked. Changing it requires re-approval by the client.",
  l_Exchange_rate_source: "Exchange rate source",
  l_Exchange_rate_value: "Rate",
  l_Manual_rate_hint:
    "Tenge per 1 unit of the selected currency; empty — rate from the reference",
  l_Manual_rate_hint_kzt:
    "For a KZT invoice — rate of the order price currency (tenge per 1 unit); empty — rate from the reference",
  l_Forte_only_usd_hint:
    "FORTE applies to USD only; other currencies use the NBRK rate",
  l_Invalid_manual_rate: "The rate must be greater than zero",
  l_Currency_and_rate: "Currency and rate",
  l_Invoice_resend_1c_warning:
    "The invoice will be recalculated and resent to 1C",
  l_Close_avr: "Close AVR",
  l_Close_avr_confirm: "Close the AVR for this order?",
  l_Close_avr_bulk_confirm: "Close the AVR for the selected orders ({n})?",
  l_Avr_close_title: "AVR closing",
  l_Avr_closed_info: "AVR closed {date}",
  l_Avr_close_success: "AVR closed",
  l_Avr_close_summary: "Closed: {closed}, skipped: {skipped}",
  l_Avr_close_errors: "Errors:",
  l_Avr_close_no_permission: "You do not have permission to close the AVR",
  l_Comments_all: "All",
  l_Comments_with_client: "With client",
  l_Comments_internal: "Internal",
  l_Comments_with_client_hint: "The client sees these comments in their account",
  l_Comments_internal_hint: "Visible to staff only — hidden from the client",
  l_Comments_empty: "No comments yet",
  l_Comments_empty_with_client: "Nothing has been shared with the client yet",
  l_Comments_empty_internal: "No internal comments yet",
  l_Visible_to_client: "Visible to client",
  l_Visible_to_carrier: "Visible to carrier",
  l_Internal_comment: "Internal",
  l_Author_client: "Client",
  l_Author_carrier: "Carrier",
  l_Author_employee: "Employee",
  l_Role_admin: "Admin",
  l_Role_manager: "Manager",
  l_Role_china_manager: "China manager",
  l_Role_logist: "Logistician",
  l_Role_product: "Product",
  l_Role_accountant: "Accountant",
  l_Role_broker: "Broker",
  l_You: "You",
};
